import { FC, useRef, useState } from "react"
import imageEmail from '../../../assets/images/emailImage.png'
import './index.css'

import { useNavigate, useParams } from "react-router-dom";
import Swal from 'sweetalert2';
import api from "../../../services/api";
import { usePluginspace } from "../../../hooks/usePluginspace";

import { Loading } from "../../../components/Loading";


const ResetPassword: FC = () => {
    const navigate = useNavigate()
    const { pluginspace_id } = useParams();
    const { getToken } = usePluginspace();
    const [loading, setLoading] = useState(false);

    const [password, setPassword] = useState("")
    const [passwordAgain, setPasswordAgain] = useState("")



    const validar = async () => {

        if (password !== passwordAgain) {
            Swal.fire({
                icon: 'warning',
                title: 'Atenção!',
                text: 'As senhas digitadas não são iguais.',
            })
            setPassword('')
            setPasswordAgain('')
            return

        }


        try {
            setLoading(true)
            const cpf = localStorage.getItem('cpfReset')
            const payload = {
                cpf: cpf,
                addresses: [],
                password: password
            }
            await api
                .post(
                    `/api/customer/reset_password`,
                    payload,
                    {
                        headers: {
                            Authorization: `Bearer ${await getToken()}`,
                        },
                    }
                )
                .then(async (response: any) => {
                    setLoading(false)



                    const data = response.data
                    if (!data || !data.success) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Erro',
                            text: 'Erro ao atualizar a senha,tente novamente!',
                        })
                        return
                    }

                    if (data || data.success) {
                        navigate(`/${pluginspace_id}/auth`)
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Erro',
                            text: 'Erro ao atualizar a senha,tente novamente!',
                        })
                    }

                })
                .catch((err: any) => {
                    setLoading(false)
                    Swal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: 'Erro ao atualizar a senha,tente novamente!',
                    })

                    console.log(err);
                });
        } catch (error) {
            setLoading(false)
            console.log(error)
        }
    }



    return (
        <>{
            loading ?
                (
                    <Loading
                        type="spinningBubbles"
                        color="#FFF"
                        width={64}
                        height={64}
                    />
                ) : (
                    <>
                        <div className="validateContent">
                            <div className="validateImage">
                                <img src={imageEmail} alt="Logo" />
                            </div >


                            <div className="validateText">
                                <h3>Esqueci a senha - Criar nova senha</h3>
                            </div>
                            <div className="validateText">
                                <span> Agora você pode criar uma nova senha para a sua conta! </span>
                            </div>
                            {/* Fazer os campos de confirmação de codigo */}

                            <div className="infoInputs">
                                <div className="inputs">
                                    <div className="headers">
                                        <label>Nova senha</label>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                                            <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                                        </svg>
                                    </div>
                                    <div className="password-Input">
                                        <input
                                            className="myinput"
                                            type={"password"}
                                            placeholder={"******"}
                                            value={password}
                                            onChange={(event) => setPassword(event.target.value)}
                                        />


                                    </div>
                                </div>

                                {/* Senha Aggain*/}
                                <div className="inputs">
                                    <div className="headers">
                                        <label>Repita a nova senha</label>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                                            <circle cx="4" cy="4.5" r="4" fill="#37393D" />
                                        </svg>
                                    </div>
                                    <div className="password-Input">
                                        <input
                                            className="myinput"
                                            type={"password"}
                                            placeholder={"******"}
                                            value={passwordAgain}
                                            onChange={(event) => setPasswordAgain(event.target.value)}
                                        />


                                    </div>
                                </div>
                            </div>


                            <div className="buttonResetPassword">
                                <button
                                    onClick={() => validar()}
                                ><span>Atualizar senha</span></button>
                            </div>
                        </div >
                    </>
                )

        }
        </>
    )
}

export { ResetPassword }